import { AxiosPromise } from 'axios';
import { UiResponse } from '../CommonInterfaces';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import RootStore from './RootStore';
import UiStore from './UiStore';

export default class SessionTransferStore {
  private uiStore: UiStore;

  constructor(rootStore: RootStore) {
    this.uiStore = rootStore.uiStore;
  }

  private async handleResponse<T>(apiCall: () => AxiosPromise<T>, extract: (data: T) => any) {
    try {
      const { data } = await apiCall();
      return extract(data);
    } catch (e: Error | string | any) {
      this.uiStore.handleNotice(e.response);
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
      throw e;
    }
  }

  public async start(goto: string) {
    return this.handleResponse<UiResponse>(
      () => API.put(`/transfer-session?goto=${goto}`),
      ({ params }) => [params?.sessionTransferToken, params?.ssoUrl],
    );
  }

  public async end(transferToken: string) {
    return this.handleResponse<UiResponse>(
      () => API.get('/transfer-session', { params: { transferToken } }),
      ({ redirectUrl }) => redirectUrl,
    );
  }
}
